require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-manila-street-astronomers-at-uptc.json") })
        }
      }, "path---blog-manila-street-astronomers-at-uptc");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-manila-street-astronomers-at-uptc!./.cache/json/blog-manila-street-astronomers-at-uptc.json
// module id = 380
// module chunks = 231608221292675